import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import Loading from '../Loading'
import SessionManager from '../../routes/SessionManager';
import SensorRecord from './SensorRecord';

function SensorDashboard() {

    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    const [sensors, setSensors] = useState(null)
    const [sensorActivities, setSensorActivities] = useState(null)
    const [loading, setLoading] = useState(true)
    const [sensor_group_map, setSensorGroupMap] = useState()

    useEffect(() => {
        fetchSiteLocationSensors();
        fetchSensorActivities();

    }, [])

    // shouldComponentUpdate(nextProps, nextState) {
    //     return true;
    // }

    const fetchSiteLocationSensors = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            source: "D",
            criteria: {
                from: 0,
                size: 1000,
                sensor_site_id: user.site_selected.site_id
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/remote_sensor/fetch',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    console.log('res', res);
                    var data = res.data.records;
                    setSensors(data);
                }
            },
            (err) => {
                setSensors([]);
            }
        )
    }

    const fetchSensorActivities = () => {
        let groupsFilter = [];
        groupsFilter.push({ attribute: "site_id", value: user.site_selected.site_id, operator: "=", join_by: "or" });

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            source: "M",
            criteria: {
                from: 0,
                size: 1000,
                advanced_filter: JSON.stringify(groupsFilter)
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/remote_sensor_group/fetch',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data && res.data.records && res.data.records.length > 0) {
                        let groupTemplates = [];
                        let groups = [];

                        res.data.records.map((x) => {
                            if (x.record.group_id === '0000000000000') {
                                groupTemplates.push(x.record);
                            } else {
                                groups.push(x.record);
                            }
                            return true;
                        });

                        for (let group of groupTemplates) {
                            group.group_id = 'SITESUPT';
                            group.activity_name = group.group_name;
                            group.activity_desc = group.group_desc;
                            group.activity_id = '';
                            group.site_id = user.site_selected.site_id;

                            if (Array.isArray(group.group_thresh_json)) {
                                group.activity_thresh_json = group.group_thresh_json
                            }
                        }

                        let sensorActivities = [];
                        let sensor_group_map = {};
                        for (let group of groups) {
                            group.activity_name = group.group_name;
                            group.activity_desc = group.group_desc;
                            group.activity_id = group.group_id;

                            sensor_group_map[group.group_id] = group.group_name;

                            if (Array.isArray(group.group_thresh_json)) {
                                group.activity_thresh_json = group.group_thresh_json;
                            }

                            // if (group.activity_thresh_json)
                            //     group.activity_thresh_json.concat([
                            //         {
                            //             "alert_up": "100",
                            //             "notify_me": false,
                            //             "notify_on": "always",
                            //             "sensor_id": "co",
                            //             "alert_down": "32",
                            //             "warning_up": "noop",
                            //             "warning_down": "noop",
                            //             "alert_timeout": 180
                            //         },
                            //         {
                            //             "alert_up": "100",
                            //             "notify_me": false,
                            //             "notify_on": "always",
                            //             "sensor_id": "co2",
                            //             "alert_down": "32",
                            //             "warning_up": "noop",
                            //             "warning_down": "noop",
                            //             "alert_timeout": 180
                            //         },
                            //         {
                            //             "alert_up": "90",
                            //             "notify_me": false,
                            //             "notify_on": "always",
                            //             "sensor_id": "voc",
                            //             "alert_down": "10",
                            //             "warning_up": "noop",
                            //             "warning_down": "noop",
                            //             "alert_timeout": 180
                            //         }
                            //     ]);

                            sensorActivities.push(group);
                        }

                        console.log('sensorActivities', sensorActivities);
                        setSensorActivities(sensorActivities);
                        setSensorGroupMap(sensor_group_map);
                        setLoading(false);

                    } else {
                        setSensorActivities([]);
                        setSensorGroupMap({});
                        setLoading(false);
                    }
                }
            });
    }

    const getLeftOverSensors = () => {
        let leftOverSensors = [];
        if (sensors) {
            leftOverSensors = sensors.filter(s => {
                //console.log('sensor : ' + s.sensor_serial_number + ', sensor_name : ' + s.sensor_name + ', sensor_group: ' + s.group_id);
                return (!s.hasOwnProperty('group_id') || s.group_id === ' ' || (sensor_group_map && !sensor_group_map[s.group_id]));
            });
        }
        return leftOverSensors;
    }


    let isDataFetched = sensors && sensorActivities;
    let isDataFound = isDataFetched ? sensorActivities.length > 0 : false;
    // console.log('sensors',sensors);
    return (
        <React.Fragment>
            {loading && <div className="p-3"><Loading>Loading ...</Loading></div>}

            {isDataFetched && (
                isDataFound &&
                sensorActivities.map(sensor_activity => (
                    <SensorRecord key={sensor_activity.activity_id} sensors={sensors} sensor_activity={sensor_activity}></SensorRecord>
                ))
            )}

            {sensors && sensors.length === 0 && <div className="p-3">Looks like you don't have any remote sensors yet. For more information, please contact info@sitekick.com or call 612-605-3170.</div>}
            {sensorActivities && sensors && sensors.length > 0 && <SensorRecord key={0} sensors={getLeftOverSensors()} sensor_activity={{ group_thresh_json: [] }}></SensorRecord>}

            <br />
            <br />
        </React.Fragment>
    );
}

export default SensorDashboard;